export const DashboardAdmin = {
  title: 'Administração'
}



// WEBPACK FOOTER //
// ./src/translations/pt/components/DashboardAdmin.js